export const GET_TAGS_STARTED = "GET_TAGS_STARTED"
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS"
export const GET_TAGS_FAILED = "GET_TAGS_FAILED"